import {lanGs} from './langData';
import {getSupabaseStorageUrl} from './supabaseConfig';

export const DRONE_TYPES = {
    multirotor: {
        key: 'multirotor',
        name: 'Мультироторный',
        icon: getSupabaseStorageUrl('image', 'multirotor.png')
    },
    'fixed-wing': {
        key: 'fixed-wing',
        name: 'Самолетный',
        icon: getSupabaseStorageUrl('image', 'fixed-wing.png')
    },
    helicopter: {
        key: 'helicopter',
        name: 'Вертолетный',
        icon: getSupabaseStorageUrl('image', 'helicopter.png')
    },
    hybrid: {
        key: 'hybrid',
        name: 'Гибридный',
        icon: getSupabaseStorageUrl('image', 'hybrid.png')
    },
    defDrone: {
        key: 'defDrone',
        name: 'Дрон',
        icon: getSupabaseStorageUrl('image', 'defDrone.png')
    }
};
export const PERSON_TYPES = {
    individual: {
        key: 'individual',
        name: {
            nameRu: 'Физлицо',
            nameKz: 'Жеке тұлға',
            nameEn: 'Individual'
        },

    },
    legal: {
        key: 'legal',
        name: {
            nameRu: 'Юридическое лицо',
            nameKz: 'Заңды тұлға',
            nameEn: 'Legal entity'
        }
    }
}

/**
 * Справочник типов беспилотных авиационных систем (БАС)
 */
export const SYSTEM_TYPES = {
    multirotor: {
        key: 'multirotor',
        nameRu: 'Мультироторный',
        nameKz: 'Көп роторлы',
        nameEn: 'Multirotor'
    },
    'fixed-wing': {
        key: 'fixed-wing',
        nameRu: 'Самолетный',
        nameKz: 'Ұшақ типті',
        nameEn: 'Fixed-wing'
    },
    helicopter: {
        key: 'helicopter',
        nameRu: 'Вертолетный',
        nameKz: 'Тікұшақ типті',
        nameEn: 'Helicopter'
    },
    hybrid: {
        key: 'hybrid',
        nameRu: 'Гибридный',
        nameKz: 'Гибридті',
        nameEn: 'Hybrid'
    }
};

/**
 * Справочник весовых категорий БАС
 */
export const WEIGHT_CATEGORIES = {
    less: {
        key: 'less',
        nameRu: 'Менее 0,25 кг',
        nameKz: '0,25 кг-ден кем',
        nameEn: 'Less than 0.25 kg'
    },
    more: {
        key: 'more',
        nameRu: 'Свыше 0,25 кг',
        nameKz: '0,25 кг-ден астам',
        nameEn: 'More than 0.25 kg'
    }
};

/**
 * Справочник сроков действия регистрации
 */
export const VALIDITY_PERIODS = {
    '1-year': {
        key: '1-year',
        nameRu: 'На срок 1 год',
        nameKz: '1 жылға',
        nameEn: 'For 1 year'
    },
    '3-years': {
        key: '3-years',
        nameRu: 'На срок 3 года',
        nameKz: '3 жылға',
        nameEn: 'For 3 years'
    },
    '5-years': {
        key: '5-years',
        nameRu: 'На срок 5 лет',
        nameKz: '5 жылға',
        nameEn: 'For 5 years'
    },
    '10-years': {
        key: '10-years',
        nameRu: 'На срок 10 лет',
        nameKz: '10 жылға',
        nameEn: 'For 10 years'
    }
};

/**
 * Справочник производителей БАС (популярные)
 */
export const MANUFACTURERS = {
    dji: {
        key: 'dji',
        nameRu: 'DJI',
        nameKz: 'DJI',
        nameEn: 'DJI'
    },
    autel: {
        key: 'autel',
        nameRu: 'Autel Robotics',
        nameKz: 'Autel Robotics',
        nameEn: 'Autel Robotics'
    },
    parrot: {
        key: 'parrot',
        nameRu: 'Parrot',
        nameKz: 'Parrot',
        nameEn: 'Parrot'
    },
    skydio: {
        key: 'skydio',
        nameRu: 'Skydio',
        nameKz: 'Skydio',
        nameEn: 'Skydio'
    },
    yuneec: {
        key: 'yuneec',
        nameRu: 'Yuneec',
        nameKz: 'Yuneec',
        nameEn: 'Yuneec'
    },
    other: {
        key: 'other',
        nameRu: 'Другое',
        nameKz: 'Басқа',
        nameEn: 'Other'
    }
};

/**
 * Справочник статусов собственности
 */
export const OWNERSHIP_STATUS = {
    yes: {
        key: 'yes',
        nameRu: 'Да',
        nameKz: 'Иә',
        nameEn: 'Yes'
    },
    no: {
        key: 'no',
        nameRu: 'Нет',
        nameKz: 'Жоқ',
        nameEn: 'No'
    }
};

/**
 * Справочник типов уведомлений (заголовок в Drawer по type; i18n через getText)
 */
export const NOTIFICATION_TYPES = {
    rejection: {
        key: 'rejection',
        textKey: 'Заявка на полет отклонена'
    },
    approval: {
        key: 'approval',
        textKey: 'Заявка на полет одобрена'
    },
    drone_registered: {
        key: 'drone_registered',
        textKey: 'Дрон успешно зарегистрирован'
    },
    default: {
        key: 'default',
        textKey: 'Заявка на полет на рассмотрении'
    }
};

export const getText = (key, lang) => {
    if (!key) return '';
    const item = lanGs[key];
    if (!item) return key; // Возвращаем ключ, если перевод не найден
    const normalizedLang = lang || 'nameRu';
    return item[normalizedLang] || item.nameRu || key;
};

/**
 * Проверяет, что URL безопасен для использования в href/src (защита от javascript:, data: и т.д.)
 * @param {string} url - URL для проверки
 * @returns {boolean}
 */
export const isSafeUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    const trimmed = url.trim().toLowerCase();
    return trimmed.startsWith('https://') || trimmed.startsWith('http://');
};
/*Роли и доступы:
root - имеет полный доступ без ограничений
Админ - 1) имеет ограничение на заливку данных в "Загрузка секторов" 2) "Роли и доступы" - может присваивать роль модератора, пользователя и госят (дать
 админа или root не может)
moderator - 1) загрузка секторов - нет доступа, Справочники - нет доступа, "Пользователи" - не имеет доступа ко всем пунктам , Редактор карты - не имеет доступа
user - не имеет доступа к админке
guest - - не имеет доступа к админке
*
* */
